import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { setVal2Token, getval2Token } from '../../Login/Auth';
import { uuid } from '../../../item/ItemTools';

export function SpaceDiv({ size = 3, content=<></> }) {
  return (
    <div className={"col-md-" + size}>
      {content}
    </div>
  )
}

/**
 * 一般大按鈕
 * @param {*} param0 
 */
export function SingleBigButton({ name = "", action, size = 3 }) {
  var fontSize = "btn-lg"
  return (
    <SingleButton name={name} action={action} size={size} fontSize={fontSize} />
  )
}

export function SingleButton({ title, name = "", action, size = 3, fontSize = "", color = "primary" }) {
  return (
    <div className={"col-md-" + size}>
    {
      title === undefined ? <></> :
        title === "" ? <p>&nbsp;</p> :
          <p>{title}</p>
    }
      <button type="button" className={"btn btn-" + color + " " + fontSize} onClick={e => action()}>
        {name}
      </button>
    </div>
  )
}

/**
 * 新增按鈕
 * @param {*} param0 
 */
export function AddButton({ name = "新增", btnStyle='btn-info', action, disabled=false, isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn m-r-sm "+btnStyle+" "+ rightCss} onClick={e => action()} disabled={disabled?"disabled":""}>
      <i className="fa fa-plus"></i>
      {name}
    </button>
  )
}

/**
 * 編輯按鈕
 * @param {*} param0 
 */
export function EditButton({ name = "編輯", action, isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn btn-warning m-r-sm " + rightCss} onClick={e => action()}>
      <i className="fa fa-edit"></i>
      {name}
    </button>
  )
}

/**
 * 取消, 清除按鈕
 * @param {*} param0 
 */
export function CancelButton({ action, name = "取消", isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  // console.log(action)
  return (
    <button type="button" className={"btn btn-white m-r-sm " + rightCss} onClick={e => action()}>
      <i className="fa fa-times"></i>
      {name}
    </button>
  )
}
/**
 * 儲存按鈕
 * @param {*} param0 
 */
export function SubmitButton({ action, name = "確定", isRight = false, icon = "fa-floppy-o" }) {
  var rightCss = isRight ? "pull-right" : ""
  // console.log(action)
  return (
    <button type="button" className={"btn btn-primary m-r-sm " + rightCss} onClick={e => action()}>
      <i className={"fa " + icon}></i> 
      {name}
    </button>
  )
}

/**
 * 取消及確認組合按鈕
 * @param {*} param0 
 */
export function CancelSubmitButton({ cancelName = "取消", cancelAction, submitName = "確定", submitAction, submitIcon = "fa-floppy-o", isRight = true }) {
  var rightCss = isRight ? "text-right" : ""
  return (
    <div className={"row " + rightCss}>
      <div className="col-sm-12">
        <CancelButton action={cancelAction} name={cancelName} />
        <SubmitButton action={submitAction} name={submitName} icon={submitIcon} />
      </div>
    </div>
  )
}

/**
 * 列表按鈕
 * @param {*} param0 
 */
export function ListButton({ action, name = "列表", isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn btn-primary btn-outline m-r-sm " + rightCss} onClick={e => action()}>
      <i className="fa fa-list"></i>
      {name}
    </button>
  )
}

/**
 * 搜尋按鈕
 * @param {*} param0 
 */
export function SearchButton({ action, item, name = "搜尋", icon = "fa-search", isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn btn-success btn-facebook btn-outline m-r-sm " + rightCss} onClick={e => action(item)}>
      {icon === "" ? <></> :
        <i className={"fa " + icon}></i>
      }
      {name}
    </button>
  )
}

/**
 * 刪除按鈕
 * @param {*} param0 
 */
export function DeleteButton({ action, id, name = "刪除", icon = "fa-delete", isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn btn-outline btn-danger m-r-sm " + rightCss} onClick={e => action(id)}>
      <i className={"fa " + icon}></i>
      {name}
    </button>
  )
}

/**
 * 上傳 or 取消扁按鈕
 * @param {*} param0 
 */
export function UploadButtonSM({ action, id, name = "上傳", icon = "fa-cloud-upload", color = "btn-primary", size = 3, isRight = false }) {
  var rightCss = isRight ? " pull-right" : ""
  return (
    <div className={"col-md-" + size}>
      <button type="button" className={"btn btn-sm btn-block " + color + rightCss} onClick={e => action(id)}>
        <i className={"fa " + icon}></i>
        {name}
      </button>
    </div>
  )
}

/**
 * 不加保按鈕
 * @param {*} param0 
 */
export function RefuseButton({ action, id, name = "刪除", icon = "fa-minus", isRight = false }) {
  var rightCss = isRight ? "pull-right" : ""
  return (
    <button type="button" className={"btn btn-danger m-r-sm " + rightCss} onClick={e => action(id)}>
      <i className={"fa " + icon}></i>
      {name}
    </button>
  )
}


/**
 * 搜尋區塊
 * @param {*} param0 
 */
export function SearchBox({ action, placeholder = "Search" }) {
  const [text, setText] = useState("")


  return (
    <div className="input-group input-group-sm col-sm-4">
      <input type="text" name="table_search" className="form-control pull-right" value={text} onChange={e => setText(e.target.value)} placeholder={placeholder} />

      <div className="input-group-btn">
        <button type="submit" className="btn btn-default" onClick={e => action(text)}><i className="fa fa-search"></i></button>
      </div>
    </div>
  )
}

export function EnableBadge({ count, text = "啟用", size = 2 }) {
  return (
    <div className={"col-sm-" + size}>
      <span className="badge badge-primary m-r-sm">{count}</span>
      {text}
    </div>
  )
}

export function DisableBadge({ count, text = "停用", size = 2 }) {
  return (
    <div className={"col-sm-" + size}>
      <span className="badge badge-danger m-r-sm">{count}</span>
      {text}
    </div>
  )
}

/**
 * 行與行多一點空白
 */
export function Space() {
  return (
    <div className="row">
      <div className="col-lg-12">
        <div>
          <p></p>
        </div>
      </div>
    </div>
  )
}

/**
 * 跳出視窗二顆按鈕
 * @param {*} param0 
 */
export function Swal2Button({ title = "儲存成功", cancelButtonText = "返回檢視", confirmAction, cancelAction }) {

  Swal.fire({
    type: 'success',
    title,
    //text: '儲存成功',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    confirmButtonText: '繼續編輯',
    cancelButtonText,
    allowEscapeKey: false,
    allowOutsideClick: false
  }).then(function (result) {
    console.log(result)
    if (result.value) {
      if (confirmAction !== undefined)
        confirmAction()
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      if (cancelAction !== undefined)
        cancelAction()
    }
  })
}

export function SingleLink({ link, name, Key, val, tokenId = "" }) {

  function toAction(e) {
    if (tokenId === "") {
      tokenId = uuid(128, 64)
    }
    setVal2Token(Key, val, tokenId)
    // var url = getval2Token(Key, tokenId)
    // console.log(val)
    // console.log(Key)
    // console.log(link)
    // console.log(tokenId)

    if (e.ctrlKey || e.metaKey) {
      window.open("/" + link + "/" + tokenId, "_blank");
    } else {
      window.location.assign("/" + link + "/" + tokenId);
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a onClick={e => toAction(e)}>{name}</a>
  )
}